export const environment = {
  apiEndpoint: 'https://hmsapiv2.web2.anasource.com/api/v1',
  mediaUrl: 'https://hmsapiv2.web2.anasource.com/PTDocs/',
  hubUrl: 'https://hmsapiv2.web2.anasource.com/hubs/hms'
};
